module.exports = __webpack_public_path__ + "img/xamarin.72b2241c.svg";